import { createFileRoute } from '@tanstack/react-router';
import { CostRatesPage } from '@/features/finance';

export const Route = createFileRoute('/_auth/o/$orgId/finance/cost-rates')({
  component: CostRatesRoute,
});

function CostRatesRoute() {
  const { orgId } = Route.useParams();
  return <CostRatesPage orgId={orgId} />;
}
